module.exports = __webpack_public_path__ + "static/media/photo22.9f969fb8.jpg";